module.exports = __webpack_public_path__ + "static/media/check-melon.8c89bed1.svg";